import type { AppCopy } from '../catalogs';

export const ptAppCopy = {
  welcomeHeading: 'Como posso ajudá-lo hoje?',
  thinking: 'Pensando',
  scrollToBottom: 'Deslocar até ao fim',
  reasoning: 'Raciocínio',
  reasoningInProgress: 'em curso',
  citationPages: 'Páginas {first}–{last}',
  citationTitle: 'Excerto da fonte',
  citationLoading: 'A carregar a fonte…',
  citationUnavailable: 'O texto citado não está disponível ou já não tem acesso.',
  citationOpen: 'Abrir fonte',
  citationCopied: 'Referência copiada',
  copy: 'Copiar',
  more: 'Mais',
  tryAgain: 'Tente novamente',
  answerTruncated: 'A resposta atingiu o limite de comprimento e foi cortada.',
  continueAnswer: 'Continuar a resposta',
  exportMarkdown: 'Exportar como Markdown',
  edit: 'Editar',
  cancel: 'Cancelar',
  update: 'Atualizar',
  previous: 'Anterior',
  next: 'Próximo',
  messagePlaceholder: 'Envie uma mensagem…',
  projectHomePlaceholder: 'Nova conversa em {project}',
  sharedChatEveryone: 'Todos na {company} podem ler este chat',
  sharedChatOnePerson: '1 pessoa pode ler este chat',
  sharedChatPeople: '{count} pessoas podem ler este chat',
  forkedChatPlaceholder: 'Continue com as suas próprias ligações…',
  newAnswer: 'Nova resposta',
  messageInput: 'Entrada de mensagens',
  sendMessage: 'Enviar mensagem',
  stopGenerating: 'Pare de gerar',
  addAttachment: 'Adicionar anexo',
  removeFile: 'Remover ficheiro',
  attachmentPreview: 'Pré-visualização do anexo',
  imageAttachmentPreview: 'Visualização do anexo de imagem',
  image: 'Imagem',
  openLink: 'abrir link',
  document: 'Documento',
  file: 'Ficheiro',
  attachment: 'anexo',
  uploadFailed: 'falha no carregamento',
  uploading: 'a carregar',
  toolIncomplete: 'Incompleto',
  toolActivity: 'Atividade',
  activityThinking: 'A pensar…',
  activityWriting: 'A escrever…',
  activityWaiting: 'A aguardar a sua aprovação',
  activityStopped: 'Parado',
  activityCouldNotFinish: 'Não foi possível concluir',
  activitySources: 'fontes',
  activityShowThinking: 'Mostrar raciocínio',
  activityOpen: 'Abrir atividade',
  activitySteps: 'Passos',
  activitySourcesTab: 'Fontes',
  activityUnavailable: 'Esta atividade não está disponível.',
  activityInput: 'Entrada',
  activityOutput: 'Saída',
  activityNoSources: 'Esta resposta não citou fontes.',
  activityApprovedByReply: 'Aprovado pela sua resposta',

  toolRunning: 'Em curso',
  toolComplete: 'Concluído',
  toolNeedsApproval: 'Requer aprovação',
  toolInput: 'Entrada',
  toolCall: 'chamada de ferramenta',
  toolCalls: 'chamadas de ferramenta',
  openMenu: 'Abrir menu',
  closeMenu: 'Fechar menu',
  close: 'Fechar',
  showInTextField: 'Mostrar no campo de texto',
  settings: 'Definições',
  appearance: 'Aspeto',
  themeLight: 'Claro',
  themeDark: 'Escuro',
  themeSystem: 'Sistema',
  themeChoiceHelp:
    'Aplica-se a todos os seus dispositivos. «Sistema» segue o modo claro ou escuro de cada dispositivo.',
  themeSaveFailed: 'Não foi possível guardar o aspeto, por isso não foi alterado. Tente novamente.',
  toolUsed: 'Ferramenta utilizada',
  toolCancelled: 'Ferramenta cancelada',
  toolResult: 'Resultado:',
  toolError: 'Erro:',
  toolCancelledReason: 'Motivo do cancelamento:',
  approvalAllow: 'Permitir',
  approvalAlwaysAllow: 'Permitir sempre',
  approvalDeny: 'Recusar',
  approvalAlwaysDeny: 'Recusar sempre',
  approvalConfirm: 'Confirmar',
  approvalBack: 'Voltar',
  approvalApprovedResult: 'Aprovado pelo utilizador',
  approvalDeniedResult: 'O utilizador recusou a execução da ferramenta',
  logout: 'Sair',
  loginOrCreateAccount: 'Entrar / Criar conta',
  newChat: 'Nova conversa',
  untitledChat: 'Chat sem título',
  previousChats: 'Conversas anteriores',
  openChat: 'Abrir conversa {title}',
  moreActionsForChat: 'Mais ações para {title}',
  chatActions: 'Ações de chat',
  closeChatActions: 'Fechar ações de chat',
  deleteChatQuestion: 'Apagar conversa?',
  deleteChatDescription: 'O chat “{title}” será eliminado permanentemente.',
  deleteChat: 'Apagar conversa',
  keepChat: 'Manter conversa',
  delete: 'Apagar',
  deleting: 'A apagar…',
  chatDeleteFailed: 'O chat não pôde ser eliminado. Tente novamente.',
  settingsDescription: 'Personalize como o assistente funciona para si.',
  settingsDesktopDescription: 'Personalize a forma como o assistente lhe responde.',
  personalization: 'Personalização',
  personalizationDescription: 'Personalize as instruções que o assistente segue em cada resposta.',
  languageAndRegion: 'Língua e região',
  languageAndRegionDescription: 'Escolha o idioma e o fuso horário.',
  memories: 'Memórias',
  memoriesDescription: 'Visualize, edite ou apague o que o assistente se lembra sobre si.',
  account: 'Conta',
  accountDescription: 'Faça a gestão da conta e a eliminação permanente dos seus dados.',
  backToSettings: 'Voltar às definições',
  closeSettings: 'Fechar definições',
  settingsCategories: 'Categorias de definições',
  yourSettings: 'As suas definições',
  dataAndAccount: 'Dados e conta',
  viewAndManageMemories: 'Veja e gira o que o assistente se lembra',
  loginToUseMemories: 'Faça login para utilizar memórias',
  manageOrDeleteAccount: 'Gerir ou apagar a conta',
  unsavedChanges: 'Tem alterações por guardar',
  unsavedCloseDescription: 'Fechar as definições descartará as alterações nesta página.',
  unsavedBackDescription: 'Voltar irá descartar as alterações nesta página.',
  continueEditing: 'Continuar a editar',
  discardChanges: 'Descartar alterações',
  saveChanges: 'Guardar alterações',
  localSettingsNote: 'Guardado neste navegador. Faça login para guardar na sua conta.',
  personality: 'Personalidade',
  personalityHelp: 'Instruções personalizadas que o assistente segue em cada resposta',
  personalityPlaceholder:
    'Por exemplo: Seja conciso e concreto. Vivo em Gotemburgo e gosto de comida vegetariana.',
  timezone: 'Fuso horário',
  searchTimezone: 'Pesquisar fusos horários…',
  automaticBrowser: 'Automático (browser)',
  saved: 'Guardado {date}',
  addMemory: 'Adicionar memória',
  newMemory: 'Nova memória',
  memoryPlaceholder: 'Por exemplo: Prefiro respostas curtas e concretas.',
  editMemory: 'Editar memória',
  saveMemory: 'Guardar memória',
  deleteMemory: 'Apagar memória',
  memorySaveFailed: 'A memória não pôde ser guardada. Tente novamente.',
  memoryLimitReached: 'Pode guardar até 50 memórias. Apague uma antes de adicionar outra.',
  memoryInvalid: 'As memórias não podem conter ligações. Remova a ligação e tente novamente.',
  memoryDeleteFailed: 'A memória não pôde ser apagada. Tente novamente.',
  memoryLoadFailed: 'Não foi possível carregar as memórias.',
  loadingMemories: 'A carregar memórias…',
  emptyMemories:
    'O assistente guarda memórias sobre si enquanto fala – o que gosta, onde vive e o que faz. Pode visualizá-los, editá-los e eliminá-los aqui.',
  deleteAccountHelp:
    'Apague permanentemente a conta e todos os chats, memórias e definições relacionadas.',
  deleteAccount: 'Apagar conta',
  deleteAccountQuestion: 'Apagar permanentemente a conta?',
  deleteAccountDescription:
    'Todos os chats, mensagens, memórias, definições e credenciais de login serão eliminados. Esta ação não pode ser anulada.',
  deleteAccountConfirm: 'Sim, apagar a minha conta',
  accountDeleteFailed: 'A conta não pôde ser eliminada. Nada foi removido. Tente novamente.',
  logoutEverywhereTitle: 'Todos os dispositivos',
  logoutEverywhereHelp:
    'Termine a sessão em todos os dispositivos e navegadores onde a sua conta está aberta, incluindo este.',
  logoutEverywhere: 'Sair em todo o lado',
  logoutEverywhereQuestion: 'Sair em todos os dispositivos?',
  logoutEverywhereDescription:
    'Terá de iniciar sessão novamente em todos os dispositivos e navegadores, incluindo este. As suas conversas e definições mantêm-se como estão.',
  loggingOut: 'A sair…',
  logoutEverywhereFailed:
    'Não foi possível confirmar que terminou a sessão em todo o lado. Tente novamente ou verifique noutro dispositivo se ainda tem sessão iniciada.',
  settingsSaveFailed: 'Não foi possível guardar as definições. Tente novamente.',
  customInstructions: 'Instruções personalizadas',
  notSet: 'Não definido',
  automaticLanguage: 'Idioma automático',
  automaticTimezone: 'fuso horário automático',
  appLanguage: 'Idioma da aplicação',
  appLanguageHelp:
    'Controla toda a interface da aplicação e as datas. As respostas do assistente continuam a seguir o idioma em que escreve.',
  automaticBrowserLanguage: 'Automático (idioma do browser)',
  previousLanguageChoice: 'Escolha anterior: {language} ({locale})',
  previousLanguageChoiceCode: 'Escolha anterior ({locale})',
  canvasCopyLink: 'Copiar ligação',
  canvasLinkCopied: 'Ligação copiada',
  actionUpdatedWithEdits: 'Atualizado com as suas alterações',
  activityStepsDone: 'one:passo concluído|other:passos concluídos',
  activityResultsCount: 'one:resultado|other:resultados',
  canvasCopyLinkFailed: 'Não foi possível copiar a ligação',
  canvasOpenInAgent: 'Abrir em {agent}',
  canvasExpand: 'Expandir',
  canvasExitFullView: 'Sair da vista completa',
  webSourceUnread:
    'Ligado nesta resposta. A Poneva não leu esta página, por isso não há nada para mostrar aqui.',
  webSourceOpenOriginal: 'Abrir original',
  toolProgressSettings: 'A alterar as suas definições…',
  toolProgressAgent: 'A criar o agente…',
  toolProgressConnections: 'A procurar opções de ligação…',
  toolProgressResult: 'A preparar o seu resultado…',
  toolProgressClarification: 'A preparar um esclarecimento…',
  toolProgressKnowledge: 'A preparar uma sugestão de atualização do conhecimento…',
  toolProgressQuestion: 'A preparar uma pergunta para si…',
  toolProgressSkill: 'A dar forma à sua Skill…',
  toolErrorSettings: 'As suas definições não foram alteradas.',
  toolErrorAgent: 'Não foi possível criar o agente.',
  toolErrorConnections: 'Não foi possível carregar as opções de ligação.',
  toolErrorResult: 'O resultado não foi guardado.',
  toolErrorClarification: 'Não foi possível preparar o esclarecimento.',
  toolErrorKnowledge: 'Não foi possível preparar a sugestão de atualização do conhecimento.',
  toolErrorQuestion: 'Não foi possível preparar a pergunta.',
  toolErrorSkill: 'Não foi possível guardar o rascunho da Skill.',
  toolErrorOpenSettings: 'Abrir Definições',
  toolErrorOpenAgents: 'Abrir Agentes',
  toolErrorOpenConnections: 'Abrir Ligações',
  toolStepIncomplete: 'Este passo não foi concluído.',
  toolEarlierAttemptsFailed:
    'one:tentativa anterior não foi concluída|many:de tentativas anteriores não foram concluídas|other:tentativas anteriores não foram concluídas',
} satisfies AppCopy;
